import { FC, useMemo } from "react";
import useDeleteBlock from "hooks/services/blocks/useDeleteBlock";
import useBulkAction from "hooks/useBulkAction";
import { BulkAction, BulkActionProps } from "../BulkActionsControls/types";
import { trash2 } from "assets/icons";
import BulkActionsControlBase from "../BulkActionsControls/BulkActionsControlBase";
import { useTranslation } from "react-i18next";

const BlockBulkActionControl: FC<BulkActionProps> = (props) => {
  const { mutateAsync: deleteBlocksAsync } = useDeleteBlock();

  const { t } = useTranslation();

  const {
    bulkAction: deleteBlockBulk,
    isLoading: isDeletingBlockBulk,
    bulkResult: deleteBlockBulkResult,
  } = useBulkAction(deleteBlocksAsync);

  const actions: BulkAction[] = useMemo(
    () => [
      {
        name: t("Remove"),
        icon: trash2,
        confirmMessage: t("Are you sure you want to delete these blocks?"),
        bulkAction: deleteBlockBulk,
        bulkActionLoading: isDeletingBlockBulk,
        bulkActionResult: deleteBlockBulkResult,
      },
    ],
    [deleteBlockBulk, isDeletingBlockBulk, deleteBlockBulkResult]
  );
  return <BulkActionsControlBase {...props} actions={actions} />;
};

export default BlockBulkActionControl;
